<template>
    <div class="p-4">
        <l-l-selection @click="onSelectionClick" :timeseries="timeseries" />
        <l-l-chart ref="chart" v-show="showChart" />
    </div>
</template>

<script>
import LLSelection from "./LLSelection";
import LLChart from "./LLChart";
import HistoricalService from "@/helpers/services/viewer/historical.service";
import * as moment from "moment";
import Notify from "@/helpers/notify";

export default {
    name: "Historical",
    components: {
        LLSelection,
        LLChart,
    },
    data() {
        return {
            timeseries: [],
            showChart: false,
        };
    },
    mounted() {},
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        },
        async loadData(timeseries, from, to, onlyValidValues, viewAsBar, yaxisStart, meantype, format, coverage) {
            this.showChart = true;
            this.$refs.chart.removeSeries();
            this.$refs.chart.changeType(viewAsBar ? "bar" : "line");

            const d = await HistoricalService.observations(timeseries, from, to, onlyValidValues, viewAsBar, meantype, coverage);
            var series = d.map((ts) => {
                if (viewAsBar == true) {
                    let tickAmount = 10;
                    if (this.isMobile()) tickAmount = 6;
                    let o = { xaxis: { type: "category", tickAmount: tickAmount, label: { datetimeUTC: false } } };
                    this.$refs.chart.updateOptions(o);
                }
                var data = ts.values.map((tv) => {
                    return { x: moment(tv.datetime).format(format), y: tv.val };
                });
                return {
                    name: ts.station + " - " + ts.component,
                    type: viewAsBar ? "column" : "line",
                    data: data,
                };
            });
            this.$refs.chart.addSeries(series);
            this.$refs.chart.updateYaxisStart(yaxisStart);
        },
        async onSelectionClick(selections) {
            Notify.loadData(null, await this.loadData, selections.timeseries, selections.from, selections.to, selections.onlyValidValues, selections.viewAsBar, selections.yaxisStart, selections.meantype, selections.format, selections.coverage);
        },
    },
};
</script>
